import { useAppSelector } from '../../../../../store/hooks'
import { selectAccountId } from '../../../../../store/auth/authSlice'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useZocksQuota } from '../../../../../components/ScopedBlock/hooks'
import { getUserDisplayName } from '../aifeatures/utils'
import { useGetExternalUsersQuery } from '../../../../../store/externalUser/externalUser'
import { SelectOption } from '../../../../../components/SelectDropdown/SelectDropdown'

export const useContactFilter = () => {
  const accountId = useAppSelector(selectAccountId)
  const { hasQuota } = useZocksQuota()
  const sessionSharingAvailable = hasQuota('identity.sessionSharingEnabled.value')
  const [searchInput, setSearchInput] = useState<string>('')
  const { data: contacts, isFetching: contactsLoading } = useGetExternalUsersQuery(
    { accountId, name: searchInput, pageRequest: { page: 0, size: 50 } },
    { refetchOnMountOrArgChange: true },
  )

  const allContactsId = '{all}'
  const allContactsFilterOption = useMemo(() => ({ label: 'All Contacts', id: allContactsId }), [])

  const [contactFilterValues, setContactFilterValues] = useState<SelectOption[]>([allContactsFilterOption])
  const [selectedContactId, setSelectedContactId] = useState<string>(allContactsId)

  useEffect(() => {
    if (!contacts) {
      return
    }

    const filterValues = contacts.data.map((u) => ({ id: u.id, label: getUserDisplayName(u) })).sort((a, b) => a.label.localeCompare(b.label))
    setContactFilterValues([allContactsFilterOption, ...filterValues])
  }, [allContactsFilterOption, contacts])

  const resetContactFilter = useCallback(() => {
    setSelectedContactId(allContactsId)
  }, [])

  const handleSearchInputChange = async (searchInput: string) => {
    setSearchInput(searchInput)
  }

  return {
    contactFilterValues,
    selectedContactId,
    sessionSharingAvailable,
    setSelectedContactId,
    resetContactFilter,
    isLoading: contactsLoading,
    handleSearchInputChange,
  }
}
